module.exports = __webpack_public_path__ + "img/user-slash-solid.6c250eda.svg";